import { makeStyles } from "@material-ui/styles";

export const useVoucherStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    root1: {
      flexGrow: 1,
      position: "relative",
      overflowX: "auto",
    },
    departmentTitle: {
      fontWeight: "bold",
      fontSize: "1.7em",
    },
    table: {
      minWidth: 935,
    },
    editIconMargin: {
      marginRight: theme.spacing(1),
      backgroundColor: "white", //"#8bc34a",
      boxShadow: "none",
      borderRadius: "0.3em",
      "&:hover": {
        backgroundColor: "#717d8a",
      },
    },
    SearchInput: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    searchPaper: {
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      width: 400,
    },
    editIcon: {
      width: ".90em",
      height: ".90em",
      color: "#3d5a79 !important",
    },
    commonButtonStyle: {
      paddingTop: "3em",
      textAlign: "right",
    },
    commonButtonPosition: {
      paddingTop: "2.50em",
    },
    mainGridStyle: {
      paddingTop: "1em",
      paddingLeft: "1em",
      paddingRight: "1em",
    },
    tableMessage: {
      color: "balck",
      fontWeight: "bold",
      fontSize: "1.3em",
      textAlign: "center",
    },
    fieldLabelStyles: {
      paddingBottom: "1em",
      fontWeight: "bold",
    },
  })
);
